import { useContext } from "react";
import dataApplicationsContext from "../../context/dataApplicationsContext";
import { useNavigate } from "react-router-dom";

const CardHelpLink = ({ slug, title, description, link, containerClass, slugClass, titleClass, descriptionClass, isCardlink }) => {
  const { setIsSearchActive, setSearch } = useContext(dataApplicationsContext);

  const navigate = useNavigate();

  const handleCardNavigate = () => {
    setSearch('');
    setIsSearchActive(false);
    isCardlink && navigate(link)
    isCardlink && window.scrollTo(0,0)
  }
  const handleLinkNavigate = () => {
    !isCardlink && navigate(link)
    !isCardlink && window.scrollTo(0,0)
  }

  return (
    <div className={containerClass} onClick={handleCardNavigate}>
      {slug && <p className={slugClass}>{slug}</p>}
      {title && <p className={titleClass} onClick={handleLinkNavigate}>{title}</p>}
      <p className={descriptionClass}>{description}</p>
    </div>
  )
}

export default CardHelpLink